import useDispatch from 'hooks/useDispatch'
import { showAuthModal, hideAuthModal } from '../actions/authActions'

import useIsUserSignedIn from './useIsUserSignedIn'

const useLoginModalState = () => {
  const dispatch = useDispatch()
  const { isSignedIn, loading } = useIsUserSignedIn()

  const openLoginModal = () => dispatch(showAuthModal())
  const closeLoginModal = () => dispatch(hideAuthModal())

  return {
    currentUserSignedIn: isSignedIn,
    currentUserLoading: loading,
    openLoginModal,
    closeLoginModal,
  }
}

export default useLoginModalState
